import React, { useState } from "react";
import { Button, Icon, Modal, Message, Segment, Label } from "semantic-ui-react";
const styles = {
	scanInput: {
		borderRadius: 5,
		fontSize: 18,
		outline: 0,
		border: 0,
		minWidth: "115px",
		maxWidth: "150px",
		margin: "5px",
		textAlign: "center",
	},
};
const MyTelForTvSecModal = ({ session, setMyTelForTvSec }) => {
	const [myTel, setMyTel] = useState(session.myTelForTvSec ? session.myTelForTvSec : "");
	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			setMyTelForTvSec(myTel);
		}
	};

	return (
		<Modal
			trigger={
				<Button style={{ marginLeft: "10px", marginBottom: "3px" }} as="div" labelPosition="right">
					<Button
						color={session.myTelForTvSec ? "blue" : "orange"}
						onClick={() => {
							setMyTel(session.myTelForTvSec ? session.myTelForTvSec : "");
						}}
					>
						<Icon name="call" />
						{session.myTelForTvSec ? session.myTelForTvSec : "Ajouter mon numéro de téléphone"}
					</Button>
					{session.myTelForTvSec && (
						<Label as="a" basic pointing="left">
							Modifier le numéro
						</Label>
					)}
				</Button>
			}
			header="Je suis joignable par téléphone."
			content={
				<>
					<Message>
						Il est désormais possible pour une préleveuse de vous contacter directement par téléphone via MyLabNurse. Pour activer cette
						fonctionnalité, il faut renseigner votre numéro de téléphone complet. (Préfix Bionext +352 27 32 1, suivi de votre extension.)
					</Message>
					<Segment>
						<input
							style={styles.scanInput}
							autoFocus
							autoComplete="off"
							type="text"
							name="tel_for_tv_sec"
							onChange={(e) => setMyTel(e.target.value)}
							value={myTel}
							onKeyDown={handleKeyDown}
						/>
						{session.myTelForTvSec !== myTel && (
							<Button
								onClick={() => {
									setMyTelForTvSec(myTel);
								}}
							>
								<Icon name="check" /> Sauvegarder
							</Button>
						)}
					</Segment>
				</>
			}
			actions={[{ key: "done", content: "Fermer" }]}
		/>
	);
};
export default MyTelForTvSecModal;
